import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    startDate: z.string(), // YYYY-MM-DD
    endDate: z.string(), // YYYY-MM-DD
  }),
  response: z.object({
    excel: z.string(), // Base64
    supervisorOrgName: z.string(),
  }),
};
